<ng-container *ngFor="let c of shownCollections">
  <span bitBadge badgeType="secondary">{{ c | collectionNameFromId : collections }}</span>
</ng-container>
<ng-container *ngIf="showXMore">
  <span bitBadge badgeType="secondary">+ {{ xMoreCount }} more</span>
</ng-container>
